import { Maybe, TagCategoryType, TagType } from 'generated/graphql'
import _ from 'lodash'

export type TagCategoriesQuery = {
    event: { [key: string]: Maybe<Array<Pick<TagCategoryType, 'id' | 'order' | 'text'>>> }
}

export type TagsQuery = { event: { [key: string]: Maybe<Array<(
        Pick<TagType, 'id' | 'text' | 'color' | 'order'>
        & { category?: Maybe<Pick<TagCategoryType, 'id' | 'text' | 'order'>> }
        )>> } };

export function getCategoryFrom<T extends TagsQuery,
    U extends TagCategoriesQuery>(tagsData: T, categoriesData: U,
    tagKey: string,
    categoryKey: string) {
    const category = _.filter(tagsData?.event?.[tagKey], (tag) => tag.category !== null)
        .reduce((acc, cur) => {
            const categoryId = cur.category.id
            if (acc[categoryId]) {
                return {
                    ...acc,
                    [`${categoryId}`]: {
                        ...acc[categoryId],
                        tags: [...acc[categoryId].tags, { ...cur }]
                    }
                }
            }
            return { ...acc, [`${categoryId}`]: { ...cur.category, tags: [{ ...cur }] } }
        }, {})
    const assignedCategories = _.keys(category).map((key) => ({ ...category[key] }))
    const unassignedCategories= _.differenceBy(categoriesData?.event?.[categoryKey],
        assignedCategories, 'id')
    return [...assignedCategories, ...unassignedCategories]
}
